/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject, signal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StopIconComponent } from 'src/chatbot/icons/send-icon/stop-icon.component';
import { dataChatService } from 'src/chatbot/service/dataChat.service';

@Component({
  selector: 'cancel-button',
  standalone: true,
  imports: [
    CommonModule,

    StopIconComponent
  ],
  templateUrl: './cancelButton.component.html',
  styleUrl: './cancelButton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelButtonComponent {
  public dataChat = inject(dataChatService);
  public isInvalid = signal<boolean>(true)

  @Input() chatForm!: FormGroup;

  ngOnInit(){
    this.chatForm.valueChanges.subscribe(() => {
      this.isInvalid.set(this.chatForm.invalid)
    });
  }

 }
